import React from 'react';
import { Layout } from 'antd';

const { Header } = Layout;

const Topbar = () => {
  return (
    <Header className="header">
      <div>
        <span className="page-title">PAYE KART YÖNETİM PANELİ</span>
      </div>
    </Header>
  );
};

export default Topbar;
